module.exports = __webpack_public_path__ + "img/ch23_05_星空告别.6e6033d9.jpg";